import Api from './ApiZoom'

export default {
    getOne(webinarId) {
        return Api().get(`invite/link/${webinarId}`);
    }  
}